import React, { useState } from "react";
import "../../folkdashboard.css";
import { useNavigate } from "react-router-dom";
import { apiHelper, baseUrl } from "helpers/util";
import artOfMindControlImage from "../../images/art_of_mind_control_dashboard.png";
import geetaForYouthImage from "../../images/geeta_for_youth_dashboard.png";
import sundayMeetupImage from "../../images/sunday_meetup_dashboard.png";
import clubRegImage from "../../images/club_reg_dashboard.png";
import eventImage from "../../images/event_dashboard.png";
import reportImage from "../../images/report_dashboard.png";

export default function FOLKDashboard() {
    const [mobileNo, setMobileNo] = useState("");
    const [searchResult, setSearchResult] = useState("");
    const [isSearching, setIsSearching] = useState(false);

    const searchByMobileNo = async (mobileNo) => {
        if (!mobileNo.trim()) {
            setSearchResult("Please enter a mobile number");
            return;
        }
        
        try {
            setIsSearching(true);
            setSearchResult("");
            
            const response = await apiHelper.get({
                url: `${baseUrl}/api/editable_sunday_attendance`,
                params: {search_text: mobileNo},
            });

            if (response.status) {
                if (!response.json) {
                    throw new Error("Response json is undefined");
                }
                if (response.json.length === 0) {
                    setSearchResult("User doesn't exist");
                } else {
                    setSearchResult(`User found: ${response.json[0]["HK Japa User Name"] || response.json[0]["Name"] || "Unknown Name"}`);
                }
            } else {
                setSearchResult("Error occurred while searching");
            }
        } catch (error) {
            console.error("Error in searchByMobileNo:", error);
            setSearchResult("An error occurred while searching");
        } finally {
            setIsSearching(false);
        }
    };



  const navigate = useNavigate();
    return (
        <div className="folk-container">
            <h2 className="folk-header">|| Hare Krishna || <br/> Welcome to FOLK</h2>
            <div className="folk-search-section">
                <div className="folk-search-row">
                    <input 
                        className="folk-search-input"
                        type="text" 
                        placeholder="Enter mobile number to search"
                        value={mobileNo}
                        onChange={(e) => setMobileNo(e.target.value)}
                    />
                    <button 
                        className="folk-search-button"
                        onClick={() => searchByMobileNo(mobileNo)}
                        disabled={isSearching}
                    >
                        {isSearching ? "Searching..." : "Search"}
                    </button>
                </div>
                {searchResult && (
                    <div
                        className={`folk-search-result ${searchResult.includes("found") ? "folk-search-result-success" : "folk-search-result-error"}`}
                    >
                        {searchResult}
                    </div>
                )}
            </div>
            <div className="folk-options">
                <div className="folk-option" onClick={() => navigate("/aomc_attendance")}
                    style={{ cursor: "pointer" }}>
                <img className="folk-option-image" src={artOfMindControlImage} alt="AOMC Logo" loading="lazy" decoding="async" />
                    <p>AOMC</p>
                </div>
                <div className="folk-option" onClick={() => navigate("/gfy_attendance")}
                    style={{ cursor: "pointer" }}>
                    <img className="folk-option-image" src={geetaForYouthImage} alt="GFY Logo" loading="lazy" decoding="async" />
                    <p>GFY</p>
                </div>
                <div className="folk-option" onClick={() => navigate("/sunday_attendance")}
                    style={{ cursor: "pointer" }}>
                    <img className="folk-option-image" src={sundayMeetupImage} alt="Sunday Logo" loading="lazy" decoding="async" />
                    <p>Sunday Program</p>
                </div>
                <div className="folk-option" onClick={() => navigate("/club_attendance")}
                    style={{ cursor: "pointer" }}>
                    <img className="folk-option-image" src={clubRegImage} alt="CLUB Logo" loading="lazy" decoding="async" />
                    <p>CLUB</p>
                </div>
                <div className="folk-option" onClick={() => navigate("/event_attendance")}
                    style={{ cursor: "pointer" }}>
                    <img className="folk-option-image" src={eventImage} alt="Event Logo" loading="lazy" decoding="async" />
                    <p>FOLK Events</p>
                </div>
                <div className="folk-option" onClick={() => navigate("/report_details")}
                    style={{ cursor: "pointer" }}>
                    <img className="folk-option-image" src={reportImage} alt="Report Logo" loading="lazy" decoding="async" />
                    <p>Sunday Report</p>
                </div>
                 <div className="folk-option" onClick={() => navigate("/auto_attendance")}
                    style={{ cursor: "pointer" }}>
                          <img className="folk-option-image" src={sundayMeetupImage} alt="Auto Attendance Logo" loading="lazy" decoding="async" />
                    <p>Auto Attendance</p>
                </div>
                <div className="folk-option" onClick={() => navigate("/late_attendance")}
                    style={{ cursor: "pointer" }}>
                          <img className="folk-option-image" src={sundayMeetupImage} alt="Late Attendance Logo" loading="lazy" decoding="async" />
                    <p>Late Attendance</p>
                </div>
            </div>
        </div>
    );
}
